module.exports = __webpack_public_path__ + "img/1-Intersection 2.d12dc431.png";